import { api } from '@/api/ApiGateway.js'
import { useAuthStore } from '@/stores/authStore.js'

class MoodleApi
{
	login(username, password, onComplete) {
		api.post('moodle/login', {
			'username': username,
			'password': password,
		}).then(response => {
			onComplete(response)
		})
	}

	getMyCourses(onComplete) {
		const activeOrg = useAuthStore().getActiveOrganization

		api.get(`moodle/my-courses?organization_ccn=${activeOrg.ccn}`).then(response => {
			onComplete(response)
		})
	}

	getAllCourses(token, onComplete) {
		api.get('moodle/all-courses').then(response => {
			onComplete(response)
		})
	}

	getAutoLoginData(onSuccess, onError) {
		const activeOrg = useAuthStore().getActiveOrganization

		api.get(`moodle/autologin-data?organization_ccn=${activeOrg.ccn}`).then(response => {
			if (response.hasError()) {
				onError(response)
				return
			}

			if (!response.body()) {
				onError(response)
				return
			}

			if (response.body().errorcode) {
				onError(response)
			}

			onSuccess(response.body())
		})
	}
}

export const moodleApi = new MoodleApi()
